export const I18N_ABOUT_CONTEXT = 'about';

export const ABOUT_TITLE = 'title';
export const ABOUT_HEADING = 'heading';

export const ABOUT_TEXT = (number: number): string => `text.${number}`;
